import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { PermissionRow } from "namirasoft-access";
import { NSCopy, NSLoading, NSRow, NSTitle } from "namirasoft-site-react";
import { AccessProps } from "../AccessProps";
import Styles from "./IncomingPermissionSwitcher.module.css";

export interface IncomingPermissionSwitcherProps extends NSARouterMakerResult, AccessProps { }

export interface IncomingPermissionSwitcherState
{
    loading: boolean;
    switching: boolean;
    rows: PermissionRow[];
    current_id: string | null;
}

export default class IncomingPermissionSwitcher extends Component<IncomingPermissionSwitcherProps, IncomingPermissionSwitcherState>
{
    constructor(props: IncomingPermissionSwitcherProps)
    {
        super(props);
        this.state = {
            loading: true,
            switching: false,
            rows: [],
            current_id: null
        };
        this.switchTo = this.switchTo.bind(this);
        this.getCard = this.getCard.bind(this);
    }

    override componentDidMount()
    {
        this.props.servers.access.permission
            .ListIncoming(null, 1, 100, [], null)
            .then(res => this.setState({ rows: res.rows, current_id: res.current_id, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    private switchTo(owner_id: string | null, title: string)
    {
        if (this.state.switching)
            return;
        this.setState({ switching: true });
        this.props.servers.access.access.SetOwner({ owner_id }).then(() =>
        {
            this.props.notifier.onSuccess(`You have successfully switched to ${title}`);
            setTimeout(() =>
            {
                window.location.reload();
            }, 2000);
        }).catch(() =>
        {
            this.setState({ switching: false });
        });
    }

    private getCard(key: string, active: boolean, name: string, email: string, user_id: string, onClick: () => void)
    {
        let classes = [Styles.incoming_permission_switcher_card];
        if (active)
            classes.push(Styles.incoming_permission_switcher_card_active);
        else if (this.state.switching)
            classes.push(Styles.incoming_permission_switcher_card_disabled);

        return (
            <div key={key} className={classes.join(" ")} onClick={onClick}>
                <p className={Styles.incoming_permission_switcher_card_name}>
                    {name}
                </p>
                <p className={Styles.incoming_permission_switcher_card_email}>
                    {email}
                </p>
                <NSCopy value={user_id}>
                    <p className={Styles.incoming_permission_switcher_card_id}>
                        {user_id}
                    </p>
                </NSCopy>
            </div>
        );
    }

    override render()
    {
        if (this.state.loading)
            return <NSLoading title="Loading Incoming Permissions ..." />;
        if (this.state.rows.length === 0)
            return <></>;

        let user_id = this.props.account.token_manager.getUserData(u => u.id, "");
        let first_name = this.props.account.token_manager.getUserData(u => u.first_name, "");
        let last_name = this.props.account.token_manager.getUserData(u => u.last_name, "");
        let email = this.props.account.token_manager.getUserData(u => u.email, "");

        let is_my_own = !this.state.rows.some(row => row.id === this.state.current_id);

        return (
            <div className={Styles.incoming_permission_switcher_container}>
                <NSTitle
                    title="You have access to the following accounts. Click one to switch to it."
                    style={{ marginBottom: 0, fontSize: 18 }}
                />
                <NSRow>
                    {
                        this.getCard("my-own", is_my_own, (first_name + " " + last_name).trim() || email, email, user_id, () =>
                        {
                            if (!is_my_own)
                                this.switchTo(null, "your own user");
                        })
                    }
                    {
                        this.state.rows.map(row =>
                        {
                            let active = row.id === this.state.current_id;
                            let name = (row.from_first_name + " " + row.from_last_name).trim() || row.from_email;
                            return this.getCard(row.id, active, name, row.from_email, row.user_id, () =>
                            {
                                if (!active)
                                    this.switchTo(row.user_id, `user '${name}'`);
                            });
                        })
                    }
                </NSRow>
            </div>
        );
    }
}